// Action types
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const TOGGLE_DIALOG = 'TOGGLE_DIALOG'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const ADD_COUNTRY = 'ADD_COUNTRY'
export const DELETE_COUNTRY = 'DELETE_COUNTRY'
export const SEARCH_COUNTRY = 'SEARCH_COUNTRY'

// A product
//countries types here
export type MainTableProps = {
  countries: any
  sortCountries: (e: React.FormEvent<HTMLInputElement>) => void
  isNameReversing: boolean
  isPopReversing: boolean
  isRegionReversing: boolean
  // theme: any
  // switchTheme: () => void,
}

export type Countries = {
  getCountries: any
  isFetching: Boolean
  countries: any
}

export type HeaderProps = {
  countries: any
  handleSubmit: Function
  handleChange: React.FormEventHandler<HTMLInputElement>
  // handleChange: (keyword: string) => void;
  search?: string
}

export type SearchProps = {
  search?: string
  handleSubmit: Function
  // handleChange: (keyword: string) => void;
  handleChange: React.FormEventHandler<HTMLInputElement>
}

export type TitleProps = {
  countries: any
  message?: string
}

export type TableRowProps = {
  flags: any
  name: any
  capital: Array<string>
  languages: Array<string>
  population: number
  region: string
  maps: Maps
  addCountry: () => void
}

export type Country = {
  flags: any
  name: any
  languages: Array<string>
  population: number
  region: string
}

export type CountryDetails = {
  flag: string
  name: string
  capital: string
  area: number
  languages: Array<string>
  population: number
  region: string
  currencies: any
  maps: Maps
}

type Maps = {
  googleMaps: String
}

export type TableHeaderProps = {
  sortCountries: (e: React.FormEvent<HTMLInputElement>) => void
  isNameReversing: boolean
  isPopReversing: boolean
  isRegionReversing: boolean
}

export type TableCellProps = {
  sortCountries: (e: React.FormEvent<HTMLInputElement>) => void
  isNameReversing: boolean
  isPopReversing: boolean
  isRegionReversing: boolean
}

export type Cart = {
  inCart: Country[]
}

export type FlagProps = {
  flag: string
  name: string
}

export type AddCountryButtonProps = {
  addCountry: () => void
  name: string
}

export type DeleteCountryButtonProps = {
  handleDelete: () => void
}

export type PaginationProps = {
  itemsPerPage: number
  totalItems: any
  currentPage: any
  paginate: Function
}

export type GetCountriesAction = {
  type: typeof GET_COUNTRIES
  payload: {
    countries: Country[]
  }
}

export type AddCountryAction = {
  type: typeof ADD_COUNTRY
  payload: {
    country: Country
  }
}

export type DeleteCountryAction = {
  type: typeof DELETE_COUNTRY
  payload: {
    country: Country
  }
}

export type SearchCountryAction = {
  type: typeof SEARCH_COUNTRY
  payload: {
    country: Country[]
  }
}

export type CountryActions =
  | GetCountriesAction
  | AddCountryAction
  | DeleteCountryAction
  | SearchCountryAction

export type CountryState = {
  countries: Country[]
  filteredCountries: Country[]
  inCart: Country[]
  isLoading: boolean
}

export type CountState = {
  count: number
}

export type AppState = {
  countries: CountryState
}
